import {
  ParentData,
  UserData
} from "components/web-checkout/edit-userdata/edit-userdata.types";
import { useState } from "react";

export const useUserValidation = () => {
  const [userErrors, setUserErrors] = useState<Record<string, string>>({});
  const [parentErrors, setParentErrors] = useState<Record<string, string>>({});
  const [locationErrors, setLocationErrors] = useState<Record<string, string>>(
    {}
  );

  const emailRegex =
    /^[A-Za-z0-9](?!.*[._-]{2})[A-Za-z0-9._-]*[A-Za-z0-9]@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
  const validateName = (name: string, fieldLabel: string): string | null => {
    if (!name || name.trim().length < 3) {
      return "Tulis minimal 3 karakter, ya.";
    } else if (!/^[A-Za-z.\-'\s]+$/.test(name)) {
      return `Nama ${fieldLabel} mengandung karakter yang tidak valid`;
    }
    return null;
  };

  const validateLocationData = (data: {
    residence: string;
    schoolName: string;
  }): boolean => {
    const errors: Record<string, string> = {};

    if (!data.residence || data.residence.trim().length < 3) {
      errors.residence = "Isi tempat tinggal dulu ya";
    }

    if (!data.schoolName || data.schoolName.trim().length < 3) {
      errors.schoolName = "Nama sekolah harus di-isi ya";
    }

    setLocationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const validateUserData = (userFormData: UserData): boolean => {
    const errors: Record<string, string> = {};

    const nameError = validateName(userFormData.name, "murid");
    if (nameError) {
      errors.name = nameError;
    }

    if (!emailRegex.test(userFormData.email)) {
      errors.email = "Hmm... alamat email ini sepertinya salah.";
    }

    setUserErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const validateParentData = (parentFormData: ParentData): boolean => {
    const errors: Record<string, string> = {};

    const parentNameError = validateName(
      parentFormData.parentName,
      "orang tua"
    );
    if (parentNameError) {
      errors.parentName = parentNameError;
    }

    const phone = parentFormData.parentPhone;
    if (
      /\s/.test(phone) ||
      /[^0-9]/.test(phone) ||
      !/^8/.test(phone) ||
      phone.length < 9 ||
      phone.length > 13
    ) {
      errors.parentPhone =
        "Nomor HP tidak valid, harus mulai dengan ‘8’ dan minimal 8 digit ya";
    }

    setParentErrors(errors);
    return Object.keys(errors).length === 0;
  };

  return {
    userErrors,
    locationErrors,
    parentErrors,
    validateUserData,
    validateLocationData,
    validateParentData,
    setUserErrors,
    setLocationErrors,
    setParentErrors
  };
};
